import { isPossiblePhoneNumber, isValidPhoneNumber, parsePhoneNumber, } from 'libphonenumber-js/mobile';
export function isPhoneNumberGoodEnough(phoneNumber = '', countryCode) {
    const isPossibleNumber = isPossiblePhoneNumber(phoneNumber, countryCode);
    const isValidNumber = isValidPhoneNumber(phoneNumber, countryCode);
    return isValidNumber && isPossibleNumber;
}
/**
 *
 * @param phone Phone number to be formatted
 * @param selectedCountry Country code to be used for formatting
 * @returns A string with the phone number formatted according to the selected country
 * @example getFormattedPhoneNumber('1234567890', 'US') // +1 234-567-890
 */
export function getFormattedPhoneNumber(phone, selectedCountry) {
    if (phone) {
        const phoneNumber = parsePhoneNumber(phone, selectedCountry);
        return phoneNumber.formatInternational();
    }
    return phone;
}
